import request from '../../../util/SuperagentUtils';
import { buyerBookingsReportEndpoints } from '../../../requests/api-endpoints';

/**
 * How many inactive bookings to pull when looking for declined ones.
 *
 * The bookings search has no "declined only" filter — declined, cancelled and
 * expired all share the INACTIVE status group — so we fetch the inactive page
 * and keep the declined rows client-side. One page is deliberate: "why was my
 * booking declined" is about recent declines, not an audit of every one ever,
 * and a buyer with more than this many declines is a support case, not a chat
 * answer.
 */
export const DECLINED_LOOKUP_SIZE = 50;

/**
 * Fetches a page of the signed-in buyer's inactive bookings.
 *
 * The account is derived from the caller's token, so no accountId is sent. The
 * caller filters the result to `status === 'Declined'` — this request cannot,
 * because the endpoint groups all inactive states together.
 */
export const requestInactiveBuyerBookings = (): Promise<any> =>
  request.get(buyerBookingsReportEndpoints.search).query({
    activeStatus: 'INACTIVE',
    page: 0,
    size: DECLINED_LOOKUP_SIZE,
  });
